import axios from "axios";
import store from '@/store';
import router from '@/router';
import localforage from "localforage";

const baseDomain = process.env.VUE_APP_API_ENDPOINT;
const baseURL = `${baseDomain}/v1`;

const instance = axios.create({
	baseURL
});
instance.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

instance.interceptors.response.use(function(response) {
		return response;
	}, function(error) {
		if (error.response.status === 401) {
			store.dispatch("auth/clearAuth");
			localforage.setItem('intended', window.location.pathname);
			localforage.setItem(
				'alert',
				{ type: 'error', msg: 'Authentication token has expired or blacklisted.' }
			);
			router.replace("/login");
		}
		return Promise.reject(error);
	}
);
export default instance;
